// ---------------------------- เสนอเคส ให้ CEO ---------------------------- 

//------production-------
export const baseUrlArea90 = "https://api-area-investigation-1024031113167.asia-southeast1.run.app";
export const baseUrlDebts90 = "https://api-debts-1024031113167.asia-southeast1.run.app";
export const baseUrlUpImage90 = "https://api-upload-image-1024031113167.asia-southeast1.run.app";
export const baseUrlDelImage90 = "https://api-delete-image-1024031113167.asia-southeast1.run.app";
export const baseUrlApiNikki = "https://api-nikki-1024031113167.asia-southeast1.run.app";
//------production-------

//------dev-------
// export const baseUrlManager90 = "https://api-manager-539174983798.asia-southeast1.run.app/api-manager";
// ---
// export const baseUrlArea90 = "https://api-area-investigation-539174983798.asia-southeast1.run.app";
// export const baseUrlDebts90 = "https://api-debts-539174983798.asia-southeast1.run.app";
// export const baseUrlUpImage90 = "https://api-upload-image-539174983798.asia-southeast1.run.app";
// export const baseUrlDelImage90 = "https://api-delete-image-539174983798.asia-southeast1.run.app";
// export const baseUrlApiNikki = "https://api-nikki-539174983798.asia-southeast1.run.app";
//------dev-------

//------header-------
export const HEADERS_BASIC90 = {
  "Content-Type": "application/json",
  Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
};
export const HEADERS_UPIMAGE90 = {
  Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
};
//------header-------


//S4 main กฎหมาย ที่ CEO ส่งเคสมา (เส้นทดสอบ)
// export const main_wcch_lawyer = `${baseUrlArea90}/api-inv/main-wcch-lawyer`;
export const main_wdr = `${baseUrlArea90}/main-wdr`;

//S4 ยืนยันออกบอกเลิก (เส้นทดสอบ)
export const create_cc2h = `${baseUrlArea90}/api-inv/create-cc2h`;

//S4 โหลดข้อมูลการบอกเลิกก่อนออกบอกเลิก (อาจจะไม่ได้ใช้ เผื่อไว้) (เส้นทดสอบ)
export const LoadPrintPDFS4 = `${baseUrlApiNikki}/load-cc-handle`; 

//S4 โหลดข้อมูลการบอกเลิกก่อนออกบอกเลิก (อาจจะไม่ได้ใช้ เผื่อไว้) (เส้นทดสอบ)
export const lawyer_send_debs = `${baseUrlArea90}/api-inv/lawyer-send-debs`;

//S4 โหลดข้อมูลบอกเลิก บันทึก EMS
export const update_parcelno_cc_h = `${baseUrlArea90}/api-inv/update-parcelno-cc-h`;

//S4 โหลดข้อมูลบอกเลิก ยิง EMS
export const load_cc_h = `${baseUrlArea90}/api-inv/load-cc-h`;


//S2 main เฮีย (เส้นทดสอบ)
export const main_wcch_ceo = `${baseUrlArea90}/api-inv/main-wcch-ceo`;


//S4 โยกงาน ค้นหาสัญญา
export const search_wdr_contno = `${baseUrlArea90}/search-wdr-contno?contno=`;


//S4 โยกงาน โหลดทีมชุดนอก
export const load_user_wdr = `${baseUrlDebts90}/load-user-wdr`;


//S4 โยกงาน เลือกทีมตามใหม่
export const update_followcod = `${baseUrlArea90}/update-followcod`;


//S4 ออกจดหมายนอกรอบ ค้นหาสัญญาสดจาก DB2 (ไม่เขียน DB) body: { dataType, contno }
export const search_cc_manual = `${baseUrlApiNikki}/search-cc-manual`;

//S4 ออกจดหมายนอกรอบ บันทึกสัญญาที่ค้นเจอเข้าระบบบอกเลิก
//body: { user, company, contractSchema, roundDate, cancelContract: [...item จาก search-cc-manual] }
export const create_cc_manual = `${baseUrlArea90}/api-inv/create-cc-manual`;

//S4 มาร์ค date_print หลังพิมพ์จดหมาย body: { date, contractSchema, user, flagStatus }
//flagStatus: 2 = สาขาธุรการ (ออกจดหมายนอกรอบ) · ไม่ส่ง/1 = เดิม
export const update_print_cc = `${baseUrlArea90}/api-inv/update-print-cc`;

//S4 โค้นหาสัญญา พิมพ์ หรือเพิ่มจดหมาย ออกมือ
//ส่งเลขสัญญาต่อท้าย path: /api-inv/check-contno/{contno} (เหมือน CHECK_CONTNO ใน apiUrlsNew)
export const api_inv_check_contno = `${baseUrlArea90}/api-inv/check-contno/`;

//S4 โหลดข้อมูลบอกเลิก ยิง EMS ออกมือ
export const load_cc_manual  = `${baseUrlArea90}/api-inv/load-cc-manual `;

//flagStatus: 2 = สาขาธุรการ (ออกจดหมายนอกรอบ) · ไม่ส่ง/1 = เดิม
export const update_print_cc_manual = `${baseUrlArea90}/api-inv/update-print-cc-manual`;


//ปิดงาน  ประวัติงานของเคส เช็คว่ามีไหม
export const  history_notefl = `${baseUrlDebts90}/api-dets/history-notefl`;
//ปิดงาน  ประวัติงานของเคส ค้นหา
export const  search_tnotefl = `${baseUrlDebts90}/api-dets/search-tnotefl`;
//ปิดงาน  ประวัติงานของเคส ปิดงาน
export const  close_tnotefl = `${baseUrlDebts90}/api-dets/close-tnotefl`;




